import { gql, useApolloClient, useMutation } from "@apollo/client"
import { StatusLink } from "./styles"
import { COACH_TOOLS_API } from "../../../../apolloClient"
import { flags, useFeatureFlags } from "../../../../lib/feature-flags"
import { navigateToEducationPgmPurchase } from "../../../../utils/educationPgmPurchase"
import { pgaTld } from "../../../utils"

export const CREATE_QUALIFYING_LEVEL_ORDER = gql`
  mutation CreateQualifyingLevelOrder {
    createQualifyingLevelOrder {
      orderNumber
    }
  }
`

export const QualifyingLevel = ({ qualifyingLevel, history }) => {
  const client = useApolloClient()
  const [isAccountPurchaseEnabled] = useFeatureFlags([
    flags.FLAG_FEAT_EDUCATION_PGM_LEVEL_PURCHASE,
  ])
  const [qualifyingLevelMutation] = useMutation(CREATE_QUALIFYING_LEVEL_ORDER, {
    context: {
      api: COACH_TOOLS_API,
    },
  })
  const materialsPurchased = qualifyingLevel?.materialsPurchased
  const handleQualifyingLevel = async () => {
    if (isAccountPurchaseEnabled) {
      await navigateToEducationPgmPurchase({
        client,
        history,
        allowNextLevelPurchase: true,
      })
      return
    }

    try {
      const { data } = await qualifyingLevelMutation()
      window.location = `https://payments.${pgaTld}/?orderSerno=${data.createQualifyingLevelOrder.orderNumber}`
    } catch (error) {
      window.rg4js("send", {
        error,
        tags: ["prospect-dashboard"],
      })
    }
  }
  return (
    <>
      {materialsPurchased ? (
        <StatusLink href="https://pgaofamerica.instructure.com/">
          Access Education Portal
        </StatusLink>
      ) : (
        <StatusLink
          onClick={handleQualifyingLevel}
          data-testid="purchase-qualifying-level"
        >
          Purchase Qualifying Level
        </StatusLink>
      )}
    </>
  )
}

export default QualifyingLevel
